export default "__VITE_ASSET__9gqVz0uI__"